module.exports = __webpack_public_path__ + "assets/img/Srf2026_Website_Logo.eef53c03.png";